// extracted by mini-css-extract-plugin
module.exports = {"page":"Login_page__18-nI","password":"Login_password__IqnO5","eye":"Login_eye__2d9T2"};